var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-detail__price",
      style: !_vm.mounted ? "opacity: 0;" : "opacity: 1",
    },
    [
      _vm.discountPercent
        ? _c("div", { staticClass: "product-detail__discount" }, [
            _c("span", [
              _vm._v(
                "\n            " + _vm._s(_vm.discountPercent) + "\n        "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "product-detail-price",
          class: { "product-detail-price--sale": _vm.hasCrossPrice },
        },
        [
          _vm.showDynamicPrice
            ? [
                _c("span", {
                  domProps: {
                    innerHTML: _vm.$translate(
                      "Ceres::Template.dynamicVariationPrice",
                      {
                        price: _vm.$options.filters.currency(
                          _vm.variationTotalPrice,
                          true
                        ),
                      }
                    ),
                  },
                }),
              ]
            : [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._f("currency")(
                      _vm.variationTotalPrice,
                      true
                    ),
                  },
                }),
              ],
          _vm._v(" "),
          _vm.showCrossPrice && _vm.hasCrossPrice
            ? _c("span", { staticClass: "product-detail-price--uvp" }, [
                _c(
                  "del",
                  [
                    _vm.hasSpecialOffer
                      ? [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm._f("itemCrossPrice")(
                                  _vm.currentVariation.prices.default.data[
                                    "unitPrice" + _vm.appendNet
                                  ],
                                  true
                                )
                              ) +
                              "\n                "
                          ),
                        ]
                      : [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.currentVariation.prices.rrp.data[
                                    "unitPrice" + _vm.appendNet
                                  ]
                                )
                              ) +
                              "\n                "
                          ),
                        ],
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "product-detail-price__additional" }, [
        _vm.currentVariation.unit
          ? _c("div", { staticClass: "product-detail-price--base" }, [
              _vm.currentVariation.variation.mayShowUnitPrice
                ? _c("span", [
                    _vm._v(
                      "\n                (" +
                        _vm._s(
                          _vm.$translate("OD3dprimaV2::Template.basePrice")
                        ) +
                        "\n                " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm._f("specialOffer")(
                              _vm.variationGraduatedPriceContent,
                              _vm.currentVariation.prices,
                              "data",
                              "basePrice" + _vm.appendNet
                            )
                          )
                        ) +
                        "/" +
                        _vm._s(_vm.unitName) +
                        ")\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-md-inline" }, [_vm._v(" ")]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "product-detail-price--vat" },
          [
            _vm.appendNet !== ""
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$translate("Ceres::Template.singleItemExclVAT")
                      ) +
                      "\n            "
                  ),
                ]
              : [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$translate("Ceres::Template.singleItemInclVAT")
                      ) +
                      "\n            "
                  ),
                ],
            _vm._v(
              "\n            " +
                _vm._s(_vm.$translate("Ceres::Template.singleItemExclusive")) +
                "\n            "
            ),
            _vm.hasShippingCostsCategoryId
              ? _c(
                  "a",
                  {
                    attrs: {
                      "data-toggle": "modal",
                      href: "#shippingscosts",
                      title: _vm.$translate(
                        "Ceres::Template.singleItemShippingCosts"
                      ),
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.singleItemShippingCosts"
                          )
                        ) +
                        "\n            "
                    ),
                  ]
                )
              : _c(
                  "a",
                  {
                    attrs: {
                      title: _vm.$translate(
                        "Ceres::Template.singleItemShippingCosts"
                      ),
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.singleItemShippingCosts"
                          )
                        ) +
                        "\n            "
                    ),
                  ]
                ),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }